import { FppFilterSettings } from "@/features/search-filter/types/FppFilterSettings";

export const statisticsBySellerFilterSettings: FppFilterSettings = {
  sellerEnabled: true,
};
